import Tutorial from '@/widgets/Tutorial';
import modal from '@/utils/modal.js';
import eventbus from '@/utils/eventbus';

function openTutorialModal(options) {
    // @TODO ensure merchant config initialized etc?
    const m = modal.create(Tutorial, true, options);
    m.body.setAttribute('data-gmf', ''); // This signals that we are already handling this element (so for example elAttach wont mess with it)
    m.body.classList.add('gmf-tutorial-modal');
}

eventbus.on('openTutorialModal', openTutorialModal);

export default openTutorialModal;
